import { createSlice } from '@reduxjs/toolkit'
import { getFields } from '@utils/constants'

const THEME_CONFIG = {
  ...window.appData,
}

const initialState = {
  fields: {
    // mobileNumber: '',
    //gstNumber: '',
    // termsAndConditions: false,
    ...getFields(THEME_CONFIG.fieldsSet.common),
    partnerDetails: getFields(THEME_CONFIG.fieldsSet.partnerDetails),
    generalDetails: getFields(THEME_CONFIG.fieldsSet.generalDetails),
    bankDetails: getFields(THEME_CONFIG.fieldsSet.bankDetails),
  },
  locations: [],
  disabledFields: {},
  disabledLocationFields: [],
  errors: {},
  locationErrors: [],
  currentLocationIndex: 0,
  isUnderReview: false,
}

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    addRegistrationDetails: (state, action) => {
      state.fields = { ...state.fields, ...action.payload }
    },
    addPartnerDetails: (state, action) => {
      state.fields.partnerDetails = { ...state.fields.partnerDetails, ...action.payload }
    },
    addBankDetails: (state, action) => {
      state.fields.bankDetails = { ...state.fields.bankDetails, ...action.payload }
    },
    setCurrentLocationIndex: (state, action) => {
      state.currentLocationIndex = action.payload
    },
    addLocationDetails: (state) => {
      state.locations.push({ ...getFields(THEME_CONFIG.fieldsSet.locationFields) })
    },
    removeLocationDetails: (state, action) => {
      state.locations.splice(action.payload, 1)
    },
    updateLocationDetails: (state, action) => {
      state.locations[action.payload.index] = { ...state.locations[action.payload.index], ...action.payload.values }
    },
    addDisabledFields: (state, action) => {
      state.disabledFields = { ...state.disabledFields, ...action.payload }
    },
    addDisabledLocationFields: (state) => {
      state.disabledLocationFields.push({ city: true, state: true })
    },
    updateDisabledLocationFields: (state, action) => {
      state.disabledLocationFields[action.payload.index] = action.payload.values
    },
    removeDisabledLocationFields: (state, action) => {
      state.disabledLocationFields.splice(action.payload, 1)
    },
    addErrors: (state, action) => {
      state.errors = action.payload
    },
    addLocationErrors: (state, action) => {
      state.locationErrors = action.payload
    },
    setIsUnderReview: (state, action) => {
      state.isUnderReview = action.payload
    },
    clearRegistrationDetails: (state) => {
      state.fields = initialState.fields
      state.locations = []
      state.disabledFields = {}
      state.disabledLocationFields = []
      state.errors = {}
      state.locationErrors = []
      state.currentLocationIndex = 0
    },
  },
})

export const {
  addRegistrationDetails,
  addPartnerDetails,
  addBankDetails,
  addLocationDetails,
  removeLocationDetails,
  updateLocationDetails,
  addDisabledFields,
  addDisabledLocationFields,
  updateDisabledLocationFields,
  removeDisabledLocationFields,
  addErrors,
  addLocationErrors,
  clearRegistrationDetails,
  setCurrentLocationIndex,
  setIsUnderReview,
} = registrationSlice.actions
export default registrationSlice.reducer
